import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";

import { Helmet } from "react-helmet-async";

import {
  Avatar,
  Box,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Chip,
  Grid,
  TextField as MuiTextField,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  Input,
} from "@material-ui/core";
import Swal from "sweetalert2";

import {
  CloudUpload as MuiCloudUpload,
  Apartment as ApartmentIcon,
  BusinessCenter as BusinessCenterIcon,
  Email as EmailIcon,
  PhoneIphone as PhoneIphoneIcon,
} from "@material-ui/icons";

import { spacing } from "@material-ui/system";
import {
  updateInfoProfile,
  getClientBankInfo,
} from "../../services/profileSettingService";
import LocalizationPreferences from "../../components/LocalizationPreferences";

const Card = styled(MuiCard)(spacing);

const TextField = styled(MuiTextField)(spacing);

const Button = styled(MuiButton)(spacing);

const CloudUpload = styled(MuiCloudUpload)(spacing);

const CenteredContent = styled.div`
  text-align: center;
`;

const HeroCard = styled(Card)`
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, #0f172a 0%, #1d4e89 55%, #5fa8d3 100%);
  color: #fff;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);
`;

const SectionCard = styled(Card)`
  border-radius: 24px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
`;

const Panel = styled.div`
  border-radius: 20px;
  padding: 20px;
  background: ${(props) => props.background || "#ffffff"};
  border: 1px solid rgba(148, 163, 184, 0.12);
  height: 100%;
`;

const SectionTitle = styled(Typography)`
  font-weight: 700;
  margin-bottom: 6px;
`;

const SectionDescription = styled(Typography)`
  color: #64748b;
  margin-bottom: 18px;
`;

const AccentButton = styled(Button)`
  && {
    border-radius: 14px;
    padding: 12px 18px;
    box-shadow: none;
  }
`;

const InfoChip = styled(Chip)`
  && {
    margin-right: 8px;
    margin-bottom: 8px;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.16);
  }
`;

const BigAvatar = styled(Avatar)`
  width: 140px;
  height: 140px;
  margin: 0 auto ${(props) => props.theme.spacing(2)}px;
`;

function Private() {
  let localStg = JSON.parse(sessionStorage.getItem("token_store"));
  const [name, setName] = React.useState(localStg.name);
  const [lastname, setLastName] = React.useState(localStg.lastName);
  const [phone, setPhone] = React.useState(localStg.phoneNumber);
  const [celular, setCelular] = React.useState(localStg.mobileNumber);
  const [streetAddress, setStreetAddress] = React.useState(
    localStg.streetAddress
  );
  const phoneRegexp = /^(?:[+][0-9]{2}\s?[0-9]{3}[-]?[0-9]{3,}|(?:[(][0-9]{3}[)]|[0-9]{3})\s*[-]?\s*[0-9]{3}[-][0-9]{4})(?:\s*x\s*[0-9]+)?/;

  const [preview, setPreview] = React.useState("");

  React.useEffect(() => {
    sessionStorage.getItem("preview-profile-image") && preview
      ? document.querySelector("#imagePreview").setAttribute("src", preview)
      : document
          .querySelector("#imagePreview")
          .setAttribute("src", localStg.profilePic);
  });

  const updateProfile = () => {
    let temp = {
      firstName: name,
      lastName: lastname,
      phoneNumber: phone,
      mobileNumber: celular,
      streetAddress: streetAddress,
      email: localStg.email,
      photo: preview,
    };

    updateInfoProfile(temp)
      .then((response) => {
        console.log(response);
        if (
          response.status === 200 ||
          response.status === 202 ||
          response.status === 201
        ) {
          localStg.name = temp.firstName;
          localStg.lastName = temp.lastName;
          localStg.phoneNumber = temp.phoneNumber;
          localStg.mobileNumber = temp.mobileNumber;
          localStg.streetAddress = temp.streetAddress;
          localStg.profilePic = temp.photo;
          sessionStorage.setItem("token_store", JSON.stringify(localStg));
          Swal.fire("Exitosamente!", "Perfil actualizado!", "success");
        } else {
          Swal.fire("Error!", "Perfil no actualizado!", "error");
        }
      })
      .catch((error) => {
        Swal.fire("Error!", "Perfil no actualizado!", "error");
        console.log(error);
      });
  };

  return (
    <SectionCard mb={6}>
      <CardContent>
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Panel background="linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)">
              <SectionTitle variant="h5">Perfil</SectionTitle>
              <SectionDescription variant="body2">
                Mantén tus datos personales y la imagen del perfil alineados con
                la identidad de tu cuenta.
              </SectionDescription>

              <CenteredContent>
                <BigAvatar
                  alt="Remy Sharp"
                  src=""
                  id="imagePreview1"
                  children={<img id="imagePreview" src="" alt=""></img>}
                />

                <label htmlFor="contained-button-file">
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={(event) => {
                      console.log(event.target.files);
                      const reader = new FileReader();

                      reader.addEventListener("load", () => {
                        console.log(reader.result);

                        sessionStorage.setItem(
                          "preview-profile-image",
                          reader.result
                        );
                        setPreview(reader.result);
                      });

                      reader.readAsDataURL(event.target.files[0]);
                    }}
                  />
                  <AccentButton
                    variant="contained"
                    color="primary"
                    component="span"
                  >
                    <CloudUpload mr={2} /> Upload
                  </AccentButton>
                </label>
              </CenteredContent>

              <Box mt={4}>
                <Typography variant="body2" color="textSecondary">
                  Correo principal
                </Typography>
                <Box mt={1} display="flex" alignItems="center">
                  <EmailIcon fontSize="small" style={{ marginRight: 8 }} />
                  <Typography variant="body1">{localStg.email}</Typography>
                </Box>
              </Box>
            </Panel>
          </Grid>

          <Grid item xs={12} md={8}>
            <Panel>
              <SectionTitle variant="h5">Informacion privada</SectionTitle>
              <SectionDescription variant="body2">
                Edita tus datos de contacto y revisa la informacion comercial
                asociada a tu perfil.
              </SectionDescription>

              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="first-name"
                    label="Nombre"
                    variant="outlined"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    fullWidth
                    my={1}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="last-name"
                    label="Apellido"
                    variant="outlined"
                    value={lastname}
                    onChange={(event) => setLastName(event.target.value)}
                    fullWidth
                    inputprops={{
                      readOnly: false,
                    }}
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="phone"
                    label="Telefono"
                    variant="outlined"
                    value={phone}
                    onChange={(event) => {
                      if (
                        event.target.value === "" ||
                        phoneRegexp.test(event.target.value)
                      ) {
                        setPhone(event.target.value);
                      }
                    }}
                    fullWidth
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="mobile"
                    label="Celular"
                    variant="outlined"
                    value={celular}
                    onChange={(event) => {
                      if (
                        event.target.value === "" ||
                        phoneRegexp.test(event.target.value)
                      ) {
                        setCelular(event.target.value);
                      }
                    }}
                    fullWidth
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="identification"
                    label="ID"
                    variant="outlined"
                    value={localStg.identification}
                    fullWidth
                    inputprops={{
                      readOnly: true,
                    }}
                    disabled
                    my={1}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="address"
                    label="Direccion"
                    variant="outlined"
                    value={streetAddress}
                    onChange={(event) => setStreetAddress(event.target.value)}
                    fullWidth
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="email"
                    label="Correo electronico"
                    variant="outlined"
                    type="email"
                    value={localStg.email}
                    fullWidth
                    disabled
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="TipoDeNegocio"
                    label="Tipo de Negocio"
                    variant="outlined"
                    value={localStg.businessType}
                    fullWidth
                    disabled
                    my={1}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    id="companyName"
                    label="Compania"
                    variant="outlined"
                    value={localStg.company}
                    fullWidth
                    disabled
                    my={1}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel id="countryLabel">Pais</InputLabel>
                  <Select
                    labelId="countryLabel"
                    id="country"
                    name="Pais"
                    disabled
                    value={localStg.country}
                    style={{ width: "100%", marginTop: 8 }}
                    input={<Input />}
                  >
                    <MenuItem selected={true} value={localStg.country}>
                      {localStg.country}
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="city"
                    label="Ciudad"
                    disabled
                    variant="outlined"
                    value={localStg.city}
                    fullWidth
                    my={1}
                  />
                </Grid>
              </Grid>

              <Box mt={4}>
                <AccentButton
                  variant="contained"
                  color="primary"
                  onClick={updateProfile}
                >
                  Save changes
                </AccentButton>
              </Box>
            </Panel>
          </Grid>
        </Grid>
      </CardContent>
    </SectionCard>
  );
}

function BankInfo() {
  const [nameBankMonetizador, setBankNameMonetizador] = useState();
  const [bankNumberMonetizador, setBankAccountNumberMonetizador] = useState();

  const checkClientType = () => {
    getClientBankInfo()
      .then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((element) => {
            if (element.originSystem === "MONETIZATION") {
              setBankNameMonetizador(element.bank.name);
              setBankAccountNumberMonetizador(element.bankAccountNumber);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    checkClientType();
  }, []);

  return (
    <SectionCard mb={6}>
      <CardContent>
        <SectionTitle variant="h5">Informacion bancaria</SectionTitle>
        <SectionDescription variant="body2">
          Datos de cuenta asociados a monetizacion, presentados en una vista mas
          limpia y facil de revisar.
        </SectionDescription>

        <Grid container spacing={6}>
          <Grid item md={6}>
            <TextField
              id="bankNameMonetizador"
              label="Nombre del Banco"
              disabled
              variant="outlined"
              value={nameBankMonetizador}
              fullWidth
              my={2}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              id="bankAccountNumberMonetizador"
              label="No. Cuenta"
              disabled
              variant="outlined"
              value={bankNumberMonetizador}
              fullWidth
              inputprops={{ readOnly: true }}
              my={2}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </SectionCard>
  );
}

function Settings() {
  const localStg = JSON.parse(sessionStorage.getItem("token_store"));

  return (
    <React.Fragment>
      <Helmet title="Configuraciones" />

      <HeroCard mb={6}>
        <CardContent>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h2" gutterBottom>
                Configuraciones
              </Typography>
              <Typography variant="body1" style={{ opacity: 0.88 }}>
                Organiza tu perfil, revisa datos empresariales y administra la
                informacion bancaria desde una experiencia mas actual.
              </Typography>
              <Box mt={3}>
                <InfoChip
                  icon={<BusinessCenterIcon />}
                  label={localStg.company}
                />
                <InfoChip
                  icon={<ApartmentIcon />}
                  label={localStg.businessType}
                />
                <InfoChip
                  icon={<PhoneIphoneIcon />}
                  label={localStg.mobileNumber}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box display="flex" justifyContent="center">
                <Avatar
                  src={localStg.profilePic}
                  style={{
                    width: 112,
                    height: 112,
                    border: "4px solid rgba(255,255,255,0.24)",
                  }}
                >
                  {localStg.name?.charAt(0)}
                </Avatar>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </HeroCard>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Private />
          <LocalizationPreferences />
          <BankInfo />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Settings;
